


const LOCALE_FOR = {
  EUR: 'de-DE',
  GBP: 'en-GB',
  USD: 'en-US',
  AUD: 'en-AU',
  CAD: 'en-CA',
  NZD: 'en-NZ',
  CHF: 'de-CH',
  BRL: 'pt-BR',
  MXN: 'es-MX',
  DKK: 'da-DK',
  NOK: 'nb-NO',
  SEK: 'sv-SE',
  PLN: 'pl-PL',
  CZK: 'cs-CZ',
  HUF: 'hu-HU',
  RON: 'ro-RO',
  BGN: 'bg-BG',
  TRY: 'tr-TR',
  ZAR: 'en-ZA',
  JPY: 'ja-JP',
  CNY: 'zh-CN',
  HKD: 'zh-HK',
  KRW: 'ko-KR',
  INR: 'en-IN',
  SGD: 'en-SG',
  THB: 'th-TH',
  ILS: 'he-IL',
  AED: 'ar-AE',
};


export const FALLBACK_CURRENCY_CONFIG = {
  base: 'EUR',
  symbols: { EUR: '€' },
};

export function formatExact(amount, code, config) {
  const target = String(code || config.base || 'EUR').toUpperCase();
  const symbol = config.symbols[target] || target;

  let number;
  try {
    number = new Intl.NumberFormat(LOCALE_FOR[target], {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    number = Number(amount).toFixed(2);
  }

  return symbol.length > 1 ? `${symbol} ${number}` : symbol + number;
}
